import React from 'react';

type updateFilterProps = any;

export const updateFilter: React.FC<updateFilterProps> = (
    dispatch,
    paymentActions,
    fetchPaymentsFilters,
    accounts,
    inputsState,
    partners,
    paymentItems,
    project,
    paymentStartDate,
    paymentEndDate,
    accrualStartDate,
    accrualEndDate,
    filter,
    status
) => {
    const newFilter = {
        ...filter,
        page: 1,
        'accounts[]': accounts.length
            ? `&${accounts.map((acc) => `accounts[]=${acc.value}`).join('&')}`
            : null,
        payment_start_date: paymentStartDate ? `&payment_start_date=${paymentStartDate}` : null,
        payment_end_date: paymentEndDate ? `&payment_end_date=${paymentEndDate}` : null,
        accrual_start_date: accrualStartDate ? `&accrual_start_date=${accrualStartDate}` : null,
        accrual_end_date: accrualEndDate ? `&accrual_end_date=${accrualEndDate}` : null,
        sum_from: inputsState.sumStart ? `&sum_from=${inputsState.sumStart}` : null,
        query: inputsState.findInput ? `&query=${inputsState.findInput}` : null,
        sum_to: inputsState.sumEnd ? `&sum_to=${inputsState.sumEnd}` : null,
        payment_item: paymentItems !== 'all' ? `&payment_item=${paymentItems}` : null,
        correspondent: partners !== 'all' ? `&correspondent=${partners}` : null,
        project: project !== 'all' ? `&project=${project}` : null,
        status: status !== 'all' ? `&status=${status}` : null,
    };

    const getQuery = Object.entries(newFilter)
        .filter(([key, value]) => value !== null)
        .map(([key, value]) => (key === 'page' ? `page=${value}` : value))
        .join('');

    dispatch(paymentActions.setQueryString(getQuery));

    dispatch(paymentActions.changeFilters(newFilter));
    dispatch(paymentActions.changeIsActiveFilters(true));
    dispatch(
        fetchPaymentsFilters(
            // @ts-ignore
            `${routable.getRoute('searchCompanyPaymentOperationsReact')}?${getQuery}`
        )
    );
};
